import {
  Component,
  Input,
  OnInit,
  AfterContentInit,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Practitioner } from "../../../../core/model/v2/practitioner/practitioner";
import { PracticeService } from "../../../../core/services/v2/practice.service";
import { PatientService } from "../../../../core/services/v2/patient.service";
import { CommonService } from "../../../../core/services/v2/common.service";
import { CodeTable } from "../../../../core/model/v2/code-table";
import { LanguageDetails } from "../../../../core/model/v2/languageDetails";
import { Specialty } from "../../../../core/model/v2/specialty";
import { DatePipe } from "@angular/common";
import { Observable } from "rxjs";
import { map, startWith, debounceTime, switchMap } from "rxjs/operators";
import { HospitalAffiliation } from "../../../../core/model/v2/hospitalAffiliation";
import { Insurance } from "../../../../core/model/v2/insurance";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import {
  AppDateAdapter,
  APP_DATE_FORMATS,
} from "../../../../core/format-datepicker";
import { Patient } from "../../../../core/models/patient/patient";
import { Referral } from "../../../../core/model/v2/appointment/referral";
import { PractitionerReferral } from "../../../../core/model/v2/practitioner/practitionerReferral";
import { GlobalDataService } from "../../../../core/services/v2/global-data.service";
import { UserService } from "../../../../core/services/v2/user.service";
import { ICDCode } from "../../../../core/model/v2/global-data/icdcode";
import { GlobalHealthSystem } from "../../../../core/model/v2/healthSystem/global-health-system";
import { WindowLoaderService } from "../../../../shared/components/window-loader/window-loader.service";
import {
  MatDialog,
  MatDialogRef,
  MatSnackBar,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { PhysicianOptionService } from "../../../../physician/shared/physician-option/physician-option.service";
import { MyErrorStateMatcher } from "../../../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component";
import { PreviewDocumentComponent } from "../../../../shared/components/preview-document/preview-document.component";
import { WorkingHours } from "../../../../core/model/v2/workinghours";

@Component({
  selector: "app-sidebar-physician-edit",
  templateUrl: "./sidebar-physician-edit.component.html",
  styleUrls: ["./sidebar-physician-edit.component.scss"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class SidebarPhysicianEditComponent implements OnInit {
  @Input() sectionName: string;
  @Input() practitionerData: Practitioner;
  @Input() patientData: Patient;
  @Output() toggleEvent = new EventEmitter();
  @Input() selectedHS: GlobalHealthSystem;
  @Input() isCurrentUserProfile: boolean;

  errorMessage: string;
  editorData;
  codeTable: CodeTable;
  languages: LanguageDetails[];
  specialty: Specialty[];
  referralData: Referral;
  stepNo: number = 1;
  nextValue: string = "Next Step";
  step1Validated: boolean = false;
  practId: number;
  zipCode: string = "";
  searchText: string;

  insurances: Insurance[];
  tempInsurances: Insurance[];
  updatedInsurances: Insurance[];
  showHideSelected = false;

  physicianSearchName: string;

  codeTableSuffix: CodeTable;
  practitionerEdit: Practitioner;
  affilicationCtrl = new FormControl();
  filteredAffiliations: Observable<HospitalAffiliation[]>;
  selected = false;
  healthsystemDetails: GlobalHealthSystem;

  icdOptions: ICDCode[];
  currentUserId: number;

  //#region FormControls
  physicianBioMatcher = new MyErrorStateMatcher();

  dobFormControl = new FormControl("", [Validators.required]);
  genderFormControl = new FormControl("", [Validators.required]);
  languagesFormControl = new FormControl("", [Validators.required]);
  educationFormControl = new FormControl("", []);

  physicianBioForm: FormGroup = new FormGroup({
    dob: this.dobFormControl,
    gender: this.genderFormControl,
    languages: this.languagesFormControl,
    education: this.educationFormControl,
  });

  physicianSpecialtyMatcher = new MyErrorStateMatcher();

  specialtyFormControl = new FormControl("", [Validators.required]);
  subSpecialtyFormControl = new FormControl("", []);
  boardCertifiedFormControl = new FormControl("", [Validators.required]);

  physicianSpecialtyForm: FormGroup = new FormGroup({
    specialty: this.specialtyFormControl,
    subspecialty: this.subSpecialtyFormControl,
    boardCertified: this.boardCertifiedFormControl,
  });

  basicMatcher = new MyErrorStateMatcher();

  firstNameFormControl = new FormControl("", [Validators.required]);
  middleNameFormControl = new FormControl("", []);
  lastNameFormControl = new FormControl("", [Validators.required]);
  suffixFormControl = new FormControl("", []);
  titleFormControl = new FormControl("", []);

  basicForm: FormGroup = new FormGroup({
    firstname: this.firstNameFormControl,
    middlename: this.middleNameFormControl,
    lastname: this.lastNameFormControl,
    suffix: this.suffixFormControl,
    title: this.titleFormControl,
  });

  workingHoursMatcher = new MyErrorStateMatcher();

  whDaysFormControl = new FormControl("", [Validators.required]);
  whTimeFromFormControl = new FormControl("", [Validators.required]);
  whTimeToFormControl = new FormControl("", [Validators.required]);

  whForm: FormGroup = new FormGroup({
    days: this.whDaysFormControl,
    timeFrom: this.whTimeFromFormControl,
    timeTo: this.whTimeToFormControl,
  });

  //#endregion

  constructor(
    private _practiceService: PracticeService,
    private _commonService: CommonService,
    private _userService: UserService,
    private _datePipe: DatePipe,
    private _snackBar: MatSnackBar,
    private _loaderService: WindowLoaderService,
    public dialog: MatDialog
  ) {
    this.filteredAffiliations = this.affilicationCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((val) => {
        return this._filterAffilications(val || "");
      })
    );
  }

  ngOnDestroy() {
    if (this.sectionName != "referPatient") this.intializePhysician();
  }

  ngOnInit() {
    this._loaderService.show();
    if (this.sectionName != "referPatient") this.intializePhysician();

    // this.referralData = new Referral;
    // this.referralData.validICD = false;
    // this.selectedUrgency = 'STATINSIDE24HOURS';

    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.practId = userDetails.practitionerId; // ['practitionerId'];
        this.currentUserId = userDetails.id; //['id'];
      },
      (error) => {
        console.error(error);
      },
      () => {
        this._loaderService.hide();
      }
    );
  }

  cancel() {
    this.showHideSelected = true;
    this.stepNo = 1;
    this.nextValue = "Next Step";
    this.showSelected();
    this.toggleEvent.emit(this.practitionerData);
  }

  intializePhysician() {
    this.practitionerEdit = { ...this.practitionerData };

    this.firstNameFormControl.setValue(
      this.practitionerData ? this.practitionerData.firstName : null
    );
    this.middleNameFormControl.setValue(
      this.practitionerData ? this.practitionerData.middleName : null
    );
    this.lastNameFormControl.setValue(
      this.practitionerData ? this.practitionerData.lastName : null
    );
    this.titleFormControl.setValue(
      this.practitionerData ? this.practitionerData.title : null
    );

    this.editorData = this.practitionerData ? this.practitionerData.bio : null;
    this.boardCertifiedFormControl.setValue(
      this.practitionerData ? this.practitionerData.boardCertified : null
    );
    this.dobFormControl.setValue(
      this.practitionerData ? this.practitionerData.birthDate : null
    );
    this.languagesFormControl.setValue(
      this.practitionerData && this.practitionerData.practitionerLanguages
        ? this.practitionerData.practitionerLanguages.map(
            ({ languageId }) => languageId
          )
        : []
    );
    this.educationFormControl.setValue(
      this.practitionerData ? this.practitionerData.education : null
    );

    this.loadCodes();

    this.getAllInsurances();
    this.updatedInsurances = this.practitionerData
      ? this.practitionerData.practitionerInsurance
      : null;
    //console.log('selectedHS', this.selectedHS);
    this.loadWorkingHours();
  }

  saveAboutMe() {
    const self = this;
    this._practiceService
      .updatePhysicianAboutMe(this.editorData, this.practitionerData.id)
      .subscribe((userData) => {
        self.practitionerData.bio = this.editorData;
        self.toggleEvent.emit(self.practitionerData);
      });
  }

  loadCodes() {
    const genderCode = this.practitionerData
      ? this.practitionerData.gender
      : null;
    const pspecialty = this.practitionerData
      ? this.practitionerData.specialty
      : null;
    const psubspecialty = this.practitionerData
      ? this.practitionerData.subSpecialty
      : null;
    const psuffix = this.practitionerData ? this.practitionerData.suffix : null;

    this._commonService.getItemsForAllCodeNames().subscribe(
      (codes) => {
        this.codeTable = codes.codeTable.filter(function (obj: any) {
          return obj.codeName === "GENDER";
        })[0];
        this.genderFormControl.setValue(
          this.codeTable.codeItemTables.filter(function (obj) {
            return obj.itemValue === genderCode;
          })[0]
        );

        this.codeTableSuffix = codes.codeTable.filter(function (obj: any) {
          return obj.codeName === "SUFFIX";
        })[0];
        this.suffixFormControl.setValue(
          this.codeTableSuffix.codeItemTables.filter(function (obj) {
            return obj.itemValue === psuffix;
          })[0]
        );
      },
      (error) => {
        console.error(error);
      }
    );

    this._commonService.getLanguages().subscribe(
      (response) => {
        this.languages = response.languages;
      },
      (error) => {
        console.error(error);
      }
    );

    this._commonService.getSpecialty().subscribe(
      (response) => {
        this.specialty = response.specialties;

        this.specialtyFormControl.setValue(
          this.specialty.find((obj) => obj.name == pspecialty)
        );
        this.subSpecialtyFormControl.setValue(
          this.specialty.find((obj) => obj.name == psubspecialty)
        );
      },
      (error) => {
        console.error(error);
      }
    );
  }

  savePhysicianBio() {
    if (this.physicianBioForm.invalid) {
      return;
    }

    const physicianbio = {
      gender: this.genderFormControl.value.itemValue,
      practitionerId: this.practitionerData.id,
      practitionerLanguages: this.languagesFormControl.value,
      dateOfBirth: this._datePipe.transform(
        this.dobFormControl.value,
        "MM/dd/yyyy"
      ),
      specialty: this.practitionerData.specialty,
      subSpecialty: this.practitionerData.subSpecialty,
      boardCertified: this.practitionerData.boardCertified,
      education: this.educationFormControl.value,
    };

    const self = this;
    this._practiceService.updatePhysicianBio(physicianbio).subscribe(
      (userData) => {
        self.practitionerData.gender = self.genderFormControl.value
          ? self.genderFormControl.value.itemValue
          : null;
        self.practitionerData.birthDate = self.dobFormControl.value;
        self.practitionerData.practitionerLanguages = self.languages
          .map((lang) => {
            if (self.languagesFormControl.value.includes(lang.id)) {
              return { languageId: lang.id, languageName: lang.name };
            }
          })
          .filter((notUndefined) => notUndefined !== undefined);
        self.practitionerData.education = self.educationFormControl.value;
        self.toggleEvent.emit(self.practitionerData);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  savePhysicianSpecialty() {
    if (this.physicianSpecialtyForm.invalid) {
      //console.log('invalid', this.physicianSpecialtyForm);
      return;
    }
    const physicianbio = {
      practitionerId: this.practitionerData.id,
      specialty: this.specialtyFormControl.value
        ? this.specialtyFormControl.value.name
        : null,
      subSpecialty: this.subSpecialtyFormControl.value
        ? this.subSpecialtyFormControl.value.name
        : null,
      boardCertified: this.boardCertifiedFormControl.value,

      gender: this.practitionerData.gender,
      practitionerLanguages: this.practitionerData.practitionerLanguages.map(
        ({ languageId }) => languageId
      ),
      dateOfBirth: this.practitionerData.birthDate,
    };
    //console.log('selectlang', this.languagesFormControl.value);
    const self = this;
    this._practiceService.updatePhysicianBio(physicianbio).subscribe(
      (userData) => {
        self.practitionerData.specialty = self.specialtyFormControl.value
          ? self.specialtyFormControl.value.name
          : null;
        self.practitionerData.subSpecialty = self.subSpecialtyFormControl.value
          ? self.subSpecialtyFormControl.value.name
          : null;
        self.practitionerData.boardCertified =
          self.boardCertifiedFormControl.value;

        self.toggleEvent.emit(self.practitionerData);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  saveProfileName() {
    if (this.basicForm.invalid) {
      //console.log('invalid', this.basicForm);
      return;
    }
    const physicianName = {
      practitionerId: this.practitionerEdit.id,
      firstName: this.firstNameFormControl.value,
      middleName: this.middleNameFormControl.value,
      lastName: this.lastNameFormControl.value,
      suffix: this.suffixFormControl.value
        ? this.suffixFormControl.value.itemValue
        : null,
      professionalDesignation: this.titleFormControl.value,
    };
    const self = this;
    this._practiceService.updatePhysicianName(physicianName).subscribe(
      (userData) => {
        self.practitionerEdit.firstName = self.firstNameFormControl.value;
        self.practitionerEdit.middleName = self.middleNameFormControl.value;
        self.practitionerEdit.lastName = self.lastNameFormControl.value;
        self.practitionerEdit.title = self.titleFormControl.value;

        self.practitionerData = self.practitionerEdit;
        self.practitionerData.suffix = this.suffixFormControl.value
          ? this.suffixFormControl.value.itemValue
          : null;
        self.toggleEvent.emit(self.practitionerData);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  _filterAffilications(value: string): Observable<any[]> {
    return this._practiceService.getHealthSystemsByName(value).pipe(
      map((a) =>
        a.healthSystems.filter((option) => {
          return option.name.toLowerCase().indexOf(value.toLowerCase()) === 0;
        })
      )
    );
  }

  optionClicked(event: Event, affiliation: HospitalAffiliation) {
    event.stopPropagation();
    const self = this;
    self.selected = true;
    this._practiceService.getHealthSystemByNPI(affiliation.npi).subscribe(
      (data) => {
        self.healthsystemDetails = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  savehospitalAffiliation() {
    const affiliationDetails = {
      practitionerId: this.practitionerEdit.id,
      npi: this.healthsystemDetails.npi,
    };
    const self = this;
    this._practiceService
      .updatePhysicianAffiliation(affiliationDetails)
      .subscribe(
        (userData) => {
          self.practitionerData.hospitalAffiliation.push(
            self.healthsystemDetails
          );
          self.toggleEvent.emit(self.practitionerData);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  filterSpecialty(val) {
    if (this.specialty)
      return this.specialty.filter(
        (unit) => unit.name.toLowerCase().indexOf(val.toLowerCase()) > -1
      );
    else return this.specialty;
  }

  //#region Insurance
  resetInsurance() {
    this.showHideSelected = true;
    this.showSelected();
  }

  getAllInsurances() {
    this._commonService.getInsurances().subscribe(
      (list) => {
        this.insurances = list.insurances;
        this.checkForSelectedInsurances();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  checkForSelectedInsurances() {
    this.insurances.forEach((list, i) => {
      if (this.updatedInsurances)
        this.updatedInsurances.forEach((selected) => {
          if (list.pokitDokId === selected.pokitDokId) {
            this.insurances[i].checked = true;
          }
        });
    });
    this.tempInsurances = this.insurances;
  }

  changeList(selected, ind) {
    if (!this.insurances[ind].checked) {
      this.insurances[ind].checked = true;
    } else {
      this.insurances[ind].checked = false;
    }
  }

  selectAll() {
    this.insurances.forEach((ele, i) => {
      ele.checked = true;
    });
  }

  deselectAll() {
    this.insurances.forEach((ele, i) => {
      ele.checked = false;
    });
  }

  showSelected() {
    this.findInsurance("");
    if (!this.showHideSelected) {
      this.insurances = this.insurances.filter((ele) => ele.checked === true);
      this.showHideSelected = true;
    } else {
      this.insurances = this.tempInsurances;
      this.showHideSelected = false;
    }
  }

  findInsurance(keyword: string) {
    keyword = keyword.trim();
    this.insurances = this.tempInsurances;
    if (keyword !== "") {
      this.insurances = this.insurances.filter((ele) =>
        ele.name.toLowerCase().match(keyword.toLowerCase())
      );
    }
  }

  saveInsurances() {
    //console.log(this.tempInsurances.filter(ele => ele.checked === true));

    const ids = [];
    this.updatedInsurances = this.tempInsurances.filter(
      (ele) => ele.checked === true
    );
    this.updatedInsurances.filter((ele) => ids.push(ele.id));

    const req = {
      practitionerId: this.practitionerData.id,
      practitionerInsurancePlanIds: ids,
    };
    this._practiceService.updateInsurances(req).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.practitionerData.practitionerInsurance = this.updatedInsurances;
          this.cancel(); // to close the sidebar after saving the data
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  //#endregion

  //#region ReferPatient
  // selectedUrgency: string;
  // urgencyOptions: any[] = [
  //   {
  //     itemValue: 'STATINSIDE24HOURS',
  //     itemDescription: 'STAT - Inside 24 Hours'
  //   },
  //   {
  //     itemValue: 'ASAP24TO48HOURS',
  //     itemDescription: 'ASAP - 24 to 48 Hours'
  //   },
  //   {
  //     itemValue: 'NEXTAVAILABLE',
  //     itemDescription: 'Next Available..'
  //   }
  // ];

  //#endregion

  //#region WorkingHours

  workingHours = [
    {
      days: [""],
      timeFrom: "",
      timeTo: "",
    },
  ];
  newWorkingHours: WorkingHours[];

  addWorkingHours(): void {
    this.workingHours.push({
      days: [],
      timeFrom: "",
      timeTo: "",
    });
  }
  updateFromWorkingHours(index: number, item: any): void {
    //console.log('From', item);
    if (this.workingHours.length > 0 && this.workingHours.length > index) {
      this.workingHours[index].timeFrom = item;
    }
  }
  updateToWorkingHours(index: number, item: any): void {
    //console.log('to',item);
    if (this.workingHours.length > 0 && this.workingHours.length > index) {
      this.workingHours[index].timeTo = item;
    }
  }

  updateDays(index: number, chkcontrol: any, days: string[]) {
    //console.log(chkcontrol);
    this.workingHours[index].days = days;
  }

  removeWorkingHours(index: number): void {
    if (this.workingHours.length > 0 && this.workingHours.length > index) {
      this.workingHours.splice(index, 1);
    }
    if (this.workingHours.length == 0) {
      this.workingHours.push({
        days: [],
        timeFrom: "",
        timeTo: "",
      });
    }
  }

  loadWorkingHours() {
    this.workingHours = [];
    this.newWorkingHours = [];
    if (this.selectedHS)
      this.selectedHS.workingHours.forEach((item) =>
        item.hours.forEach((h) => {
          var whItems = this.workingHours.find(
            (wh) =>
              wh.timeFrom == h.split("-")[0].trim() &&
              wh.timeTo == h.split("-")[1].trim()
          );
          if (whItems) {
            if (!whItems.days.find((d) => d == item.day))
              whItems.days.push(item.day);
          } else {
            this.workingHours.push({
              days: [item.day],
              timeFrom: h.split("-")[0].trim(),
              timeTo: h.split("-")[1].trim(),
            });
          }
        })
      );

    if (this.workingHours.length == 0) {
      this.workingHours.push({
        days: [],
        timeFrom: "",
        timeTo: "",
      });
    } else if (this.workingHours.length > 1)
      this.workingHours = this.workingHours.filter(
        (wh) => wh.days && wh.timeTo
      );
  }

  saveWorkingHours() {
    this.errorMessage = "";
    //if (this.whForm.invalid) {
    //  console.log('invalid', this.whForm);
    //  return;
    //}
    if (
      !this.workingHours.find(
        (wh) =>
          wh.days.length > 0 && wh.timeFrom.length > 0 && wh.timeTo.length > 0
      )
    ) {
      this.errorMessage = "Working hours is required";
      return;
    }

    this.newWorkingHours = [];
    this.workingHours.forEach((wh) => {
      wh.days.forEach((d) => {
        var whDay = this.newWorkingHours.find((nwh) => nwh.day == d);
        if (!whDay) {
          this.newWorkingHours.push({
            day: d,
            hours: [wh.timeFrom + " - " + wh.timeTo],
          });
        } else {
          if (!whDay.hours.find((h) => h == wh.timeFrom + " - " + wh.timeTo))
            whDay.hours.push(wh.timeFrom + " - " + wh.timeTo);
        }
      });
    });

    this.selectedHS.workingHours = this.newWorkingHours;
    //console.log('newselected', this.selectedHS);

    const physicianWH = {
      practitionerId: this.practitionerData.id,
      userId: this.isCurrentUserProfile ? this.currentUserId : 0,
      healthSystemId: this.selectedHS.id,
      workingHours: this.newWorkingHours,
    };

    const self = this;
    this._practiceService.updatePractitionerWorkingHours(physicianWH).subscribe(
      (res) => {
        if (res.resultStatus.isSuccess) {
          if (res.result) {
            var practHS = self.practitionerData.healthSystems.find(
              (h) => h.id == self.selectedHS.id
            );
            if (practHS) {
              practHS.workingHours = self.newWorkingHours;
            }
            self.toggleEvent.emit(self.practitionerData);
            self._snackBar.open(
              "Working hours were successfully updated",
              "Ok",
              {
                duration: 5000,
              }
            );
          } else {
            this._snackBar.open(`Working hours could not be updated`, "Ok");
          }
        } else {
          console.error(res);
          this._snackBar.open(
            `Working hours could not be updated: ${res.resultStatus.message}`,
            "Ok"
          );
        }
      },
      (error) => {
        console.error(error);
        this._snackBar.open(
          `Working hours could not be updated${
            error.error && error.error.resultStatus
              ? ": " + error.error.resultStatus.message
              : ""
          }`,
          "Ok",
          {
            duration: 5000,
          }
        );
      }
    );
  }
  //#endregion
}

@Component({
  selector: "dialog-overview-example-dialog",
  template: `<div mat-dialog-content class="p-0 m-0">
    <h1>{{ data.documentName }}</h1>
    <iframe
      id="viewer"
      type="text/html"
      width="100%"
      [src]="showDoc()"
      style="height: -webkit-fill-available;"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>`,
})
export class SideBarEditDialogOverview {
  constructor(
    public dialogRef: MatDialogRef<SideBarEditDialogOverview>,
    @Inject(MAT_DIALOG_DATA) public data: File,
    private sanitizer: DomSanitizer
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  showDoc() {
    const url = URL.createObjectURL(this.data);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
